import React, { Component } from 'react';
import ReactPlayer from 'react-player';
import styled from 'styled-components';

export default class Media extends Component {
  render() {
    const { images, videos } = this.props;
    return (
      <Wrapper>
        <ImagesWrapper>
          <BigVideo>
            <ReactPlayer url={videos[0]} width="100%" height="100%" />
          </BigVideo>
          <Flex>
            <SmallImage src={images[0]} />
            <SmallImage src={images[1]} />
            <SmallImage src={images[2]} />
          </Flex>
          <LargeImage src={images[3]} />
          <LargeImage src={images[0]} />
        </ImagesWrapper>
      </Wrapper>
    );
  }
}

const Flex = styled.div`
  @media screen and (min-width: 786px) {
    max-height: 650px;
    width: 66%;

    & > * {
      display: inline-block;
      width: 31.5%;
    }
    & > *:not(:last-child) {
      margin-right: 15px;
    }
  }
`;

const ImagesWrapper = styled.div`
  @media screen and (min-width: 786px) {
    flex-flow: column wrap;
    width: 100%;
    max-height: 900px;
    margin-left: -32px;
    display: flex;
    & > * {
      margin: 8px;
    }
  }
`;

const BigVideo = styled.div`
  max-width: 1200px;
  border-radius: 4px;
  height: 400px;
  padding: 32px;
  @media screen and (min-width: 786px) {
    width: 66%;
    padding: 0;
    margin: 8px;
    height: 400px;
  }
`;

const Wrapper = styled.div`
  @media screen and (min-width: 786px) {
    padding: 56px 0;
    display: flex;
    justify-content: center;
    max-width: 1000px;
    margin: 0 auto;
  }
`;

const SmallImage = styled.div`
  border-radius: 4px;
  background-image: url(${props => props.src});
  background-position: center center;
  background-size: cover;
  @media screen and (min-width: 786px) {
    height: 200px;
  }
`;

const LargeImage = styled.div`
  margin: 8px;
  border-radius: 4px;
  background-image: url(${props => props.src});
  background-position: center center;
  background-size: cover;
  @media screen and (min-width: 786px) {
    height: 300px;
    width: 33%;
  }
`;
